import { type Location } from '@koala/sdk';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StyledLoyaltyContainer } from '../../styles';
import { ConnectedStaticHeartIcon } from '@/components/account/uielements';
import StringAccessor from '@/components/cmsConfig/stringAccessor';
import { ConnectionErrorState } from '@/components/connectionError';
import { FeatureAccessor } from '@/components/featureAccessor';
import { LocationCard } from '@/components/locations/card';
import {
  StyledFavoritesFlexContainer,
  StyledNoDataContainer,
  StyledNoDataContent,
} from '@/components/uielements/favoriteCard/styles';
import { CSS_CLASSES } from '@/constants/cssClassNames';
import { FEATURE_FLAGS } from '@/constants/features';
import { globalSliceSelector } from '@/redux/global/reducer';
import meActions from '@/redux/me/actions';
import { meSliceSelector } from '@/redux/me/reducer';

export const FavoriteLocations = () => {
  const { favoriteLocations, favoriteLocationsConnectionError } = useSelector(meSliceSelector);
  const featureBag = useSelector(globalSliceSelector);
  const isFavoriteLocationsEnabled =
    // @ts-expect-error `ACCOUNT__FAVORITE_LOCATIONS_ENABLED` can't index `featureBag`.
    featureBag[FEATURE_FLAGS.ACCOUNT__FAVORITE_LOCATIONS_ENABLED];
  const dispatch = useDispatch();

  useEffect(() => {
    isFavoriteLocationsEnabled && dispatch(meActions.fetchMeFavoriteLocations());
  }, []);

  const alphabeticalFavoriteLocations =
    favoriteLocations &&
    favoriteLocations.sort((locationA: Location, locationB: Location) =>
      locationA.label > locationB.label ? 1 : -1,
    );

  return (
    <FeatureAccessor featureFlag={FEATURE_FLAGS.ACCOUNT__FAVORITE_LOCATIONS_ENABLED}>
      <StyledLoyaltyContainer>
        <StyledFavoritesFlexContainer className={CSS_CLASSES.LOYALTY.PAGE_HEADER}>
          <StringAccessor tag="h2" accessor="favorites.locations_header" html={true} />
          {favoriteLocationsConnectionError ? (
            <ConnectionErrorState
              data-testid="favorites-connection-error"
              onRetry={() => dispatch(meActions.fetchMeFavoriteLocations())}
            />
          ) : alphabeticalFavoriteLocations && alphabeticalFavoriteLocations.length ? (
            alphabeticalFavoriteLocations.map((location: Location) => (
              <LocationCard
                location={location}
                /* No `setActiveLocation` — the favourites list is not a picker. The prop is
                   optional, so the card no-ops on click. */
                favorites={true}
                key={location.id}
                editFavoriteLocation={true}
              />
            ))
          ) : (
            <StyledNoDataContainer>
              <StyledNoDataContent>
                <ConnectedStaticHeartIcon />
                <StringAccessor
                  tag="h3"
                  accessor="favorites.locations_empty_state_header"
                  html={true}
                />
                <StringAccessor
                  tag="p"
                  accessor="favorites.locations_empty_state_subheader"
                  html={true}
                />
              </StyledNoDataContent>
            </StyledNoDataContainer>
          )}
        </StyledFavoritesFlexContainer>
      </StyledLoyaltyContainer>
    </FeatureAccessor>
  );
};
